module.exports = __webpack_public_path__ + "static/img/码垛自动化产线.f589560f.png";